// Which stage this build is, and the dev-site rules (olene-platform/docs/signin.md,
// "One pool for every app and stage"). Every stage signs in against the one Olene pool,
// so dev sites admit only Olene staff and send everyone else to the real PayClear.
// REACT_APP_STAGE is written into the dev build by .github/workflows/deploy.yml; a build
// without it is prod.
export const STAGE = process.env.REACT_APP_STAGE === "dev" ? "dev" : "prod";
export const IS_DEV = STAGE === "dev";
export const PROD_APP_URL = (process.env.REACT_APP_PROD_APP_URL || "https://tspayclear.com").replace(/\/$/, "");
export const STAFF_GROUP = "olene-admin";

/** The Cognito groups in an access token (display only; the API enforces access). */
export function tokenGroups(accessToken) {
  try {
    const payload = accessToken.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const groups = JSON.parse(atob(payload))["cognito:groups"];
    return Array.isArray(groups) ? groups : [];
  } catch {
    return [];
  }
}

export function isStaff(accessToken) {
  return tokenGroups(accessToken).includes(STAFF_GROUP);
}
